import { Navigate } from "react-router-dom";

const AuthRoute = ({ auth, isAuth, Component, isOpen }) => {

    if (isAuth) {
      return <Component isOpen={isOpen} />;
    } else {
      return (
        <Navigate
          to={{
            pathname: "/",
            state: {
              next: auth.didLogout ? "/Home" : null,
            },
          }}
        />
      );
    }
};

export default AuthRoute;

/**
 * This component is used as a wrapper for any components pages that should have authorization
 * If the isAuth property is true, we render the component we pass into this component as a child
 * and if not, we redirect home - Since we want to support deep-linking, we want to check if the user signed out
 * or if they were never signed in and tried to access the protected page
 */
